const UpdateContentLightBox = () => null;

export default UpdateContentLightBox;
